/* assets/product-compare.js */
(function () {
  'use strict';

  function updateCardFromSwatch(sw, col) {
    var priceText = col.querySelector('[data-price-text]');
    var compareDisplay = col.querySelector('[data-compare-display]');
    var compareText = col.querySelector('[data-compare-text]');
    var discountDisplay = col.querySelector('[data-discount-display]');
    var discountText = col.querySelector('[data-discount-text]');
    var atcBtn = col.querySelector('[data-atc]');
    var imgLink = col.querySelector('[data-img-link]');
    var imgEl = col.querySelector('.product-compare__img-el');
    var productUrl = col.getAttribute('data-product-url') || '';
    var overridePrice = col.getAttribute('data-override-price');
    var overrideDiscount = col.getAttribute('data-override-discount');
    var overrideImage = col.getAttribute('data-override-image');

    var vid = sw.getAttribute('data-variant-id');
    var price = sw.getAttribute('data-price');
    var compare = sw.getAttribute('data-compare');
    var discount = parseInt(sw.getAttribute('data-discount') || '0', 10);
    var available = sw.getAttribute('data-available') === 'true';
    var variantImage = sw.getAttribute('data-variant-image');
    var onSale = discount > 0;

    if (priceText) {
      if (overridePrice) {
        priceText.textContent = overridePrice;
      } else if (price) {
        priceText.textContent = price;
      }
    }

    if (compareDisplay && compareText) {
      if (!overridePrice && onSale && compare) {
        compareText.textContent = compare;
        compareDisplay.hidden = false;
      } else {
        compareText.textContent = '';
        compareDisplay.hidden = true;
      }
    }

    if (discountDisplay && discountText) {
      if (overrideDiscount) {
        discountText.textContent = overrideDiscount;
        discountDisplay.hidden = false;
      } else if (onSale) {
        discountText.textContent = discount + '% OFF';
        discountDisplay.hidden = false;
      } else {
        discountText.textContent = '';
        discountDisplay.hidden = true;
      }
    }

    if (imgEl) {
      if (overrideImage) {
        imgEl.setAttribute('src', overrideImage);
        imgEl.setAttribute('srcset', overrideImage + ' 1x');
      } else if (variantImage) {
        imgEl.setAttribute('src', variantImage);
        imgEl.setAttribute('srcset', variantImage + ' 1x');
      } else {
        var originalSrc = imgEl.getAttribute('data-original-src');
        if (originalSrc) {
          imgEl.setAttribute('src', originalSrc);
          imgEl.removeAttribute('srcset');
        }
      }
    }

    if (imgLink && productUrl && vid) {
      imgLink.href = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
    }

    if (atcBtn) {
      atcBtn.setAttribute('data-variant-id', vid);
      atcBtn.disabled = !available;
      var textNode = atcBtn.querySelector('[data-atc-text]');
      if (textNode) {
        textNode.textContent = available
          ? (atcBtn.getAttribute('data-atc-default') || 'Add to Cart')
          : 'Sold out';
      }
    }
  }

  function initSection(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;

    // ===== Swatch switching =====
    var swatchGroups = root.querySelectorAll('[data-swatch-group]');
    swatchGroups.forEach(function (group) {
      var swatches = group.querySelectorAll('.product-compare__swatch');
      var col = group.closest('.product-compare__card');
      if (!col) return;

      var imgEl = col.querySelector('.product-compare__img-el');
      if (imgEl && !imgEl.getAttribute('data-original-src')) {
        imgEl.setAttribute('data-original-src', imgEl.getAttribute('src') || '');
      }

      var activeSwatch = group.querySelector('.product-compare__swatch[data-active="true"]');
      if (activeSwatch) {
        updateCardFromSwatch(activeSwatch, col);
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) {
            s.removeAttribute('data-active');
            s.setAttribute('aria-pressed', 'false');
          });
          sw.setAttribute('data-active', 'true');
          sw.setAttribute('aria-pressed', 'true');
          updateCardFromSwatch(sw, col);
        });
      });
    });

    // ===== Add to cart =====
    var atcButtons = root.querySelectorAll('[data-atc]');
    atcButtons.forEach(function (btn) {
      // store default text once
      var textNode = btn.querySelector('[data-atc-text]');
      if (textNode && !btn.getAttribute('data-atc-default')) {
        btn.setAttribute('data-atc-default', textNode.textContent.trim());
      }

      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;
        btn.setAttribute('aria-busy', 'true');
        var textNode = btn.querySelector('[data-atc-text]');
        var prevText = textNode ? textNode.textContent : '';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (res.status === 422) {
              if (textNode) textNode.textContent = 'Sold out';
              btn.disabled = true;
              return null;
            }
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(function (data) {
            if (!data) return;
            if (textNode) textNode.textContent = 'Added!';
            // Trigger theme cart drawer (T4S theme)
            try {
              if (window.T4SThemeSP && window.T4SThemeSP.Cart) {
                window.T4SThemeSP.Cart.getToFetch().finally(function () {
                  var cartLink = document.querySelector('.t4s-site-nav__cart > a');
                  if (cartLink) cartLink.click();
                });
              } else if (window.jQuery_T4NT) {
                window.jQuery_T4NT(document).trigger('cart.build');
              }
            } catch (e) {}
          })
          .catch(function (err) {
            console.error('[product-compare] add to cart error:', err);
            if (textNode) textNode.textContent = 'Try again';
          })
          .finally(function () {
            setTimeout(function () {
              btn.removeAttribute('aria-busy');
              if (textNode && prevText && textNode.textContent !== 'Sold out') {
                textNode.textContent = prevText;
              }
            }, 1500);
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-compare]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support: re-init when section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-product-compare]');
    if (root) initSection(root);
  });
})();

